import React, { useState, useEffect, useContext } from "react";
import AppContext from "./context";
import AsyncStorage from "@react-native-community/async-storage";
import Axios from "axios";
import Challenges from "./Challenges";

const parseURL = () => {
  const u = window.location.pathname.split("/");
  if (!u[1]) return undefined;
  return {
    tour: u[1],
    stop: u[2] ? Number(u[2]) : -1,
  };
};

const prepareTour = (tour) => {
  tour.totalChallenges = 0;
  tour.totalScore = 0;
  tour.challengesWon = 0;
  tour.challengesLost = 0;
  tour.inventory = [];
  tour.totalInventory = 0;
  tour.totalPuzzles = 0;
  tour.totalLetters = 0;
  tour.album = [];
  tour.totalArtifacts = 0;
  tour.badgeInventory = 0;
  tour.badgeAlbum = 0;
  tour.badgePuzzle = 0;
  tour.badgeLetter = 0;
  tour.totalPossibleScore = 0;
  tour.unlockedStop = 0;
  tour.stops.forEach((s) => {
    if (s.challenges) {
      tour.totalChallenges = tour.totalChallenges + s.challenges.length;

      s.challenges.forEach((c) => {
        if (c.objectType) {
          switch (c.objectType) {
            case "Text":
            case "Audio":
            case "Object":
              tour.totalInventory++;
              break;
            case "Puzzle":
              tour.totalPuzzles++;
              break;
            case "Letter":
              // console.log(s, c);
              tour.totalLetters++;
              break;
          }
          if (c.challengeType === "TakePhoto") {
            tour.totalArtifacts++;
          }
        }
        tour.totalPossibleScore = tour.totalPossibleScore + c.score;
      });
    }
  });

  tour.letters = Array(tour.totalLetters)
    .fill()
    .map((_, i) => {
      return { objectName: "?", key: String(i) };
    });

  tour.puzzles = Array(tour.totalPuzzles)
    .fill()
    .map((_, i) => {
      return { objectName: "?", key: String(i) };
    });

  let stopKey = 0;
  tour.waypoints.forEach((w) => {
    // console.log(w);
    w.stopKey = stopKey;
    if (w.linkTo === "stop") {
      stopKey++;
    }
  });
  return tour;
};

export default function Loader() {
  const [urlData] = useState(parseURL());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { setTour, setStop } = useContext(AppContext);
  const [homeScreen, setHomeScreen] = useState(false);

  useEffect(() => {
    if (urlData) {
      AsyncStorage.getItem("progress-" + urlData.tour).then((saved) => {
        if (saved) {
          var _t = JSON.parse(saved);
          // console.log(_t, urlData.stop);
          if (!_t.stops[urlData.stop]) {
            setHomeScreen(true);
            //setError("Stop not found.");
            //return false;
          }else if (!_t.stops[urlData.stop].challenges.length) {
            //setError("This stop doesn't have challenges.");
            setHomeScreen(true);
            //return false;
          }

          setStop(urlData.stop);
          setTour(_t);
          setLoading(false);
        } else {
          Axios.get("https://api3.guidigo.com/tour/json/" + urlData.tour)
            .then((d) => {
              if (d.data) {
                const tourData = prepareTour(d.data);
                // console.log(tourData);
                if (!d.data.stops[urlData.stop]) {
                  setHomeScreen(true);
                  //setError("Stop not found.");
                  //return false;
                }
                else if (!d.data.stops[urlData.stop].challenges.length)
                  setHomeScreen(true);
                  //setError("This stop doesn't have challenges.");
                  AsyncStorage.setItem(
                    "raw-" + urlData.tour,
                    JSON.stringify(tourData)
                  );
                setTour(tourData);
                setStop(urlData.stop);
                setLoading(false);
              } else {
                setError("Tour not found or some other error happened.");
                setLoading(false);
              }
            })
            .catch((e) => {
              // console.log("error " + e);
              setError("Tour not found or some other error happened.");
              setLoading(false);
            });
        }
      });
    }
  }, []);

  if (!urlData) return <div style={{ margin: 20 }}>URL wrong.</div>;
  if (error) return <div style={{ margin: 20 }}>{error}</div>;
  if (loading) return <div style={{ margin: 20 }}>Loading...</div>;

  if(homeScreen) return <Challenges />;
  return <Challenges />;
}
